AddressAvailability.Status.Views.Notes = class Notes extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    return this.listenTo(this.model, "change:hours", this.render);
  }

  // RENDERING

  render() {
    this.$el.html(
      window.Sparkle.Client.jstTemplate(this.template)({
        note: this.model.get("note"),
        specialNote: this.model.get("specialNote"),
      }),
    );
    return this;
  }
};
AddressAvailability.Status.Views.Notes.prototype.tagName = "section";
AddressAvailability.Status.Views.Notes.prototype.className = "address-availability address-availability--notes";
AddressAvailability.Status.Views.Notes.prototype.template =
  "application/components/address_availability/status/templates/notes";
